<div class="validation-hint" [ngClass]="classes">
    <span [innerHTML]="message"></span>
</div>
